module.exports = __webpack_public_path__ + "static/media/appbg.fd66cbd2.png";